import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Loading } from '../../../common/loading'
import { selectIsLoadingTopYear } from './topIndustryPlayers/store/slice'
import { getTopYear } from './topIndustryPlayers/store/thunk'

export const FiscalYear = ({ children, isFetchAPI, isShowLoading }) => {
  const dispatch = useDispatch()

  const isLoading = useSelector(selectIsLoadingTopYear)

  useEffect(() => {
    if (isFetchAPI) {
      dispatch(getTopYear())
    }
  }, [])

  if (isLoading && isShowLoading) {
    return (
      <div className="positionRelative h100">
        <Loading />
      </div>
    )
  }

  return children
}

FiscalYear.propTypes = {
  children: PropTypes.node.isRequired,
  isFetchAPI: PropTypes.bool,
  isShowLoading: PropTypes.bool,
}

FiscalYear.defaultProps = {
  isFetchAPI: true,
  isShowLoading: true,
}
